import api from '../../../services/api';
import { normalizeOrderWarehouseSummary } from '../../../dto/orderWarehouseSummary';
import type { OrderWarehouseSummary } from '../../../types/orderWarehouseSummary';

export async function fetchOrderWarehouseSummary(orderId: string): Promise<OrderWarehouseSummary> {
  const { data } = await api.get(`/orders/${encodeURIComponent(orderId)}/warehouse-summary`);
  return normalizeOrderWarehouseSummary(data);
}

export async function acceptOrderAverageCost(orderId: string): Promise<void> {
  await api.post(`/orders/${encodeURIComponent(orderId)}/average-cost`);
}
